export default __webpack_public_path__ + "static/media/correct.a7b1cde9.mp3";